import { Status } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { StatusType } from '@/types/status';

type FallbackType = 'loading' | 'error' | 'noData';

const STATUS_TYPE_MAP: Record<FallbackType, StatusType> = {
  loading: StatusType.loading,
  error: StatusType.error,
  // StatusType.noData maps to 'info' — not the same string as 'noData'
  noData: StatusType.noData,
};
const toStatusType = (type: FallbackType): StatusType => STATUS_TYPE_MAP[type];

export const GeneralFallback = ({ type }: { type: FallbackType }) => {
  const { t } = useTranslation('status');

  return (
    <div className="w-full h-full flex items-center justify-center min-h-20">
      <Status title={t(`general.${type}.title`)} type={toStatusType(type)}>
        {t(`general.${type}.description`)}
      </Status>
    </div>
  );
};
